import { render } from "./PikleInvitationCard.vue?vue&type=template&id=c8c6fb06&scoped=true"
import script from "./PikleInvitationCard.vue?vue&type=script&lang=js"
export * from "./PikleInvitationCard.vue?vue&type=script&lang=js"

import "./PikleInvitationCard.vue?vue&type=style&index=0&id=c8c6fb06&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8c6fb06"]])

export default __exports__